import {
    type FC
} from "react";
import type IChartPatternDefsProps from "./type";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    Pattern,
    Defs,
    Rect
} from "react-native-svg";
import {
    CHART_PATTERN_ANGLES
} from "../../util";

const ChartPatternDefs: FC<IChartPatternDefsProps> = ({
    customTheme,
    patterns,
    id
}) => {
    const {
        borders,
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const period = borders.subtract * 2;

    const angles = patterns.flatMap((pattern) => CHART_PATTERN_ANGLES[pattern].map((angle) => angle));

    const uniqueAngles = angles.filter((angle, index) => angles.indexOf(angle) === index);

    if(!uniqueAngles.length) {
        return null;
    }

    return <Defs>
        {
            uniqueAngles.map((angle) => <Pattern
                patternTransform={`rotate(${angle})`}
                patternUnits="userSpaceOnUse"
                id={`${id}-${angle}`}
                height={period}
                width={period}
                key={angle}
            >
                <Rect
                    fill={colors.content.container.raised}
                    width={borders.subtract}
                    x={borders.subtract}
                    height={period}
                    y={0}
                />
            </Pattern>)
        }
    </Defs>;
};
export default ChartPatternDefs;
